module.exports = __webpack_public_path__ + "media/images/max-7a7cf2f194993e55892a876126678475.jpg";